module.exports = __webpack_public_path__ + "img/애고미_이모티콘-20.9c31cf7.png";